export default __webpack_public_path__ + "static/media/llamada_SPDP_llamando.f415b448.mp3";